import { Box, Divider } from "@mui/material";

import { patientSx } from "../../styles";
import styles from "../../styles.module.scss";

const FormStepTitle = ({
  title,
  required,
}: {
  title: string;
  required: boolean;
}) => {
  return (
    <>
      <Box sx={patientSx?.stepFormTitle}>
        <p className={styles.stepTitle}>{title}</p>
        {required && (
          <p className="required" style={{ color: "#DA3923" }}>
            *required fields
          </p>
        )}
      </Box>
      <Divider sx={patientSx?.dividerStyle} />
    </>
  );
};

export default FormStepTitle;
